import HttpRequest from "@api/httpRequest";
import {RequestData} from "@models/axios";
import getPropByString from "@utils/get";

const getUrl = (): string => {
  return `/payment-reports`
};


function api() {
  return {
    getAllPaymentsReport: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/view-all`, {
        params: params
      });
    },
  
    getTypes: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/types`, {
        params: params
      });
    },
  
    getGateways: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/gateways`, {
        params: params
      });
    },
  
    getGatewayReport: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/view-all-gateway`, {
        params: params
      });
    },
    
    getTypeReport: (data: RequestData) => {
      const {params = {}} = data;
      return HttpRequest.get(`${getUrl()}/view-all-paymentType`, {
        params: params
      });
    },
  };
}

export default api();
